import { useCallback, useEffect, useState } from "react";
import { ResourceContextProvider, SimpleForm, Title, useNotify, useRedirect } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import VacationRequest from "../../Requests/components/vacation/VacationRequest";
import { useParams } from "react-router";
import dataProvider from "server/dataProvider";
import { employeeRequests } from "api/employeeApi";
import { useNotifyError } from "utils/useNotifyError";

const CorrectVacation = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const redirect = useRedirect();

  const [defaultValues, setDefaultValues] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const { id: leaveId } = useParams();

  const fetchDefaultValues = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(employeeRequests.getLeaveById(leaveId), null, "GET");
      setDefaultValues({ ...data, documents: [] });
    } catch (err) {
      notifyError(err);
    }
  }, [leaveId, notifyError]);

  const handleSubmit = async data => {
    try {
      const { documents, ...mainData } = data;
      const { data: newLeaveId } = await dataProvider.customRequest(
        employeeRequests.correctLeave(leaveId),
        mainData,
        "POST"
      );

      const newDocs = documents?.filter(doc => doc.document instanceof File) ?? [];
      for (const doc of newDocs) {
        await dataProvider.customRequest(
          employeeRequests.uploadLeaveDocument(newLeaveId),
          {
            document: { rawFile: doc.document },
            id: newLeaveId,
            description: doc.description ?? "",
          },
          "POST",
          null,
          true
        );
      }

      notify("Успешно създадохте корекция на отпуск!", { type: "success" });
      redirect(-1);
    } catch (err) {
      notifyError(err);
    }
  };

  useEffect(() => {
    if (leaveId) {
      fetchDefaultValues();
    }
  }, [leaveId, fetchDefaultValues]);

  return (
    <>
      <Title title={`Корекция на отпуск`} />
      <BackButtonToolbar />
      <ResourceContextProvider value={employeeRequests.getLeaveById(leaveId)}>
        {defaultValues && (
          <SimpleForm
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
            toolbar={false}
          >
            <VacationRequest
              showPreview={showPreview}
              setShowPreview={setShowPreview}
              isCreate={false}
              onEditConfirm={handleSubmit}
            />
          </SimpleForm>
        )}
      </ResourceContextProvider>
    </>
  );
};

export default CorrectVacation;
